import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RingLoadingEffectComponent } from './ring-loading-effect.component';

@NgModule({
	declarations: [],
	imports: [RingLoadingEffectComponent],
	exports: [RingLoadingEffectComponent],
})
export class RingLoadingEffectModule {}
